"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Header = require("web/realea/components/Header.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The Realea header: a white, generously-padded bar. The "Realea" wordmark
* sits on the left; the right side shows a "Login" link (to /login) when
* logged out, or a "Logout" button when logged in. Sign-in itself never
* happens in the header.
*
* This component is pure: it renders from props and calls the handlers it is
* given (session state + logout come from the layout), so it stays trivially
* testable.
*/
function Header(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_Header.styles.header)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      to: "/"
    }, stylex.props(_Header.styles.wordmarkLink)), {}, {
      children: "Realea"
    })), props.isLoggedIn ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      onClick: props.onLogout
    }, stylex.props(_Header.styles.control)), {}, {
      children: "Logout"
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      to: "/login"
    }, stylex.props(_Header.styles.control)), {}, {
      children: "Login"
    }))]
  }));
}
var _default = exports.default = Header;